/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface BoxItemSignature {
  Args: {
    disabled?: boolean;
    error?: boolean;
    selected?: boolean;
    tagName?: HTMLElement['tagName'];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BoxItemComponent = templateOnly<BoxItemSignature>('BoxItem');

export default BoxItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BoxItem: typeof BoxItemComponent;
    'box-item': typeof BoxItemComponent;
  }
}
